import React from "react";
import ImageType3 from "../../../../components/molecules/image-type-3";
import "../OneBigThreeSmallSectionLayout/one-big-three-small-section-layout.m.css";

const SeriesPageEpisodeListingComponent = ({
  data,
  currentPath,
  selectedButton,
  handleFetchSubSectionItems,
  activeSectionStories,
  activeSectionTotalStories,
  handleSortActSectionStories,
  hasMoreEpisodes,
  onLoadMoreEpisodes,
  isEpisodesLoading,
  behindPaywall,
  contentType
}) => {
  return (
    <div styleName="small-img-wrapper">
      <div styleName="button-wrapper">
        {data?.subSections?.length >= 1 &&
          !currentPath.startsWith("/uusimmat") &&
          !currentPath.startsWith("/lammas/uusimmat") &&
          !currentPath.startsWith("/lammas/suosittua-nyt") &&
          !currentPath.startsWith("/suosittua-nyt") &&

          data.subSections
            .filter(sectionItem => {
              const sectionName = sectionItem?.metadata?.section?.[0]?.name ?? "";
              return sectionName?.toLowerCase().includes("kausi") || /\b\d{4}\b/.test(sectionName);
            })
            .map((sectionItem, index) => {
              const sectionName = sectionItem?.metadata?.section?.[0]?.name ?? null;
              const sectionID = sectionItem?.metadata?.section?.[0]?.id ?? null;
              const isSelected = selectedButton === index ? "selected" : "";

              return (
                <button
                  key={index}
                  styleName={isSelected}
                  onClick={() =>
                    handleFetchSubSectionItems(sectionID, sectionName, index)
                  }
                >
                  {sectionName?.split("/")?.[0]?.trim() ?? ""}
                </button>
              );
            })}
      </div>

      {activeSectionStories?.length > 0 ? (
        <>
          <div styleName="count-sort">
            <h2 styleName="episodes-count">{`${activeSectionTotalStories ?? activeSectionStories.length} jaksoa`} </h2>
            <i
              onClick={handleSortActSectionStories}
              className="ri-arrow-up-down-fill"
            ></i>
          </div>

          {activeSectionStories.map((story) => (
            <div styleName="item" className="item" key={story.id}>
              <ImageType3
                story={story}
                behindPaywall={behindPaywall}
                contentType={contentType}
                aspectRatio={[[16, 9]]}
                showDateSection={data?.isSeriesPage ? false : true}
              />
            </div>
          ))}

          {hasMoreEpisodes && (
            <div styleName="load-more-wrapper">
              <button styleName="load-more-btn" onClick={onLoadMoreEpisodes} disabled={isEpisodesLoading}>
                {isEpisodesLoading ? "Ladataan..." : "Näytä lisää"}
              </button>
            </div>
          )}
        </>
      ) : (
        <>
          <div styleName="count-sort">
            <i>
              Jaksoja ei löytynyt.
            </i>
          </div>
        </>
      )}
    </div>
  );
};

export default SeriesPageEpisodeListingComponent;
